import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Fade from '@mui/material/Fade'
import { makeStyles } from '@material-ui/core/styles'
import { Box, FormHelperText, Popover } from '@mui/material'
import ImageBg from 'src/assets/Buy_Policy_Images/MotorFormBg.svg'
import CarDetails from 'src/components/BuyPolicy/insuranceScreens/motor/CarDetails'
import motorFourWheeler from 'src/assets/Buy_Policy_Images/motorFourWheeler.svg'
import ModelForm from 'src/components/BuyPolicy/insuranceScreens/motor/ModelForm'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import ExpiryPopOver from 'src/components/BuyPolicy/insuranceScreens/motor/ExpiryPopOver'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'
import kuttiImage from 'src/assets/Buy_Policy_Images/KuttiImage.svg'
import gurantee from 'src/assets/Buy_Policy_Images/Gurantee.svg'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ExistingClaimsPopOver from 'src/components/BuyPolicy/insuranceScreens/motor/ExistingClaimsPopOver'
import {
  FORM_ERROR_MESSAGES,
  getNextDate,
  MOTOR_MEMBER_DETAILS_VALIDATIONS,
  NAME_REGEX,
  PHONE_REGEX,
  POLICY_NUMBER_REGEX,
  POLICY_TYPE_ENUM,
} from 'src/utils/constants/BuyPolicyMotor'
import { getTokenForQrReport } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import { showNotificationMessage, updateTokenMotor } from 'src/actions'
import { useDispatch, useSelector } from 'react-redux'
import { formatDateMonth } from 'src/utils/commonMethods/formatDate'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import {
  existingClaims,
  expired,
  FILL_REQ_FIELDS,
  KUTTI,
  NO,
  POLICY_TYPES,
  radioOptions,
  YES,
} from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { MOTOR_FORMIK_KEYS } from 'src/utils/constants/Motor'

const MotorDialog = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { motorDetails, loggedInUserInfo } = useSelector((state) => {
    return {
      motorDetails: state?.buyPolicyMotorReducer,
      loggedInUserInfo: state?.userInfo,
    }
  })

  const vehicleDetails = motorDetails?.vehicleDetails
  const personalDetails = motorDetails?.personalDetails
  const previousPolicyDetails = motorDetails?.previousPolicyDetails
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const { open, setOpen, handleSubmit } = props
  const [selectedValue, setSelectedValue] = useState('')
  const [isActiveSection, setIsActiveSection] = useState(true)
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [loading, setLoading] = useState(false)
  const [formActive, setFormActive] = useState(false)
  const [isHighlight, setIsHighlight] = useState(false)

  const initialStateValues = {
    name: personalDetails?.name || '',
    mobileNumber: personalDetails?.mobileNumber || '',
    email: '',
    isCompany: false,
    companyName: vehicleDetails?.companyName || '',
    previousPolicyProvider:
      previousPolicyDetails?.previousPolicyProvider?.insuranceCompanyName || '',
    previousPolicyProviderFirstName:
      previousPolicyDetails?.previousPolicyProvider
        ?.insuranceCompanyFirstName || '',
    previousPolicyNumber: previousPolicyDetails?.previousPolicyNumber || '',
    policyType: '',
    existingPolicyClaim: '',
    ncb: '',
    isPolicyExpired: previousPolicyDetails?.isPolicyExpired || '',
    isPolicyExpiredBeforeDate: 'no',
    expiryDate: previousPolicyDetails?.expiryDate || '',
    expiredDate: previousPolicyDetails?.expiredDate || '',
    thirdPartyExpiryDate: '',
    thirdPartyProvider: '',
    thirdPartyPolicyNo: '',
    thirdPartyProviderFirstName: '',
    thirdPartyStartDate: '',
    regDate: motorDetails?.vehicleDetails?.regDate || '',
  }

  const motorDetailsForm = useFormik({
    initialValues: initialStateValues,
    validationSchema: Yup.object({
      name: Yup.string()
        .required(FORM_ERROR_MESSAGES?.Name_Msg)
        .matches(NAME_REGEX, MOTOR_MEMBER_DETAILS_VALIDATIONS?.nameValidation),
      mobileNumber: Yup.string()
        .required(FORM_ERROR_MESSAGES?.Mobile_Msg)
        .matches(PHONE_REGEX, MOTOR_MEMBER_DETAILS_VALIDATIONS?.phoneValidation)
        .max(10, MOTOR_MEMBER_DETAILS_VALIDATIONS?.phoneValidation)
        .min(10, MOTOR_MEMBER_DETAILS_VALIDATIONS?.phoneValidation),
      email: Yup.string().email(
        MOTOR_MEMBER_DETAILS_VALIDATIONS?.emailValidation
      ),
      isCompany: Yup.boolean(),
      companyName: Yup.string().nullable(true),
      previousPolicyProvider: Yup.string().required(
        FORM_ERROR_MESSAGES?.PreviousPolicyProvider_Msg
      ),
      previousPolicyProviderFirstName: Yup.string(),
      previousPolicyNumber: Yup.string()
        .matches(
          POLICY_NUMBER_REGEX,
          MOTOR_MEMBER_DETAILS_VALIDATIONS?.policyNumberLength
        )
        .required(FORM_ERROR_MESSAGES?.previousPolicyNumber_Msg)
        .min(8, MOTOR_MEMBER_DETAILS_VALIDATIONS?.policyNumberLength),
      policyType: Yup.string().required(FORM_ERROR_MESSAGES?.PolicyType_Msg),
      existingPolicyClaim: Yup.string().required(
        FORM_ERROR_MESSAGES?.existingPolicyClaim
      ),
      ncb: Yup.string()
        .nullable(true)
        .when(
          MOTOR_FORMIK_KEYS?.EXISTINGPOLICYCLAIM,
          (existingPolicyClaim, schema) => {
            if (existingPolicyClaim === NO) {
              return schema.required(FORM_ERROR_MESSAGES?.ncb)
            }
            return schema
          }
        ),
      isPolicyExpired: Yup.string().required(
        FORM_ERROR_MESSAGES?.isPolicyExpired
      ),
      expiryDate: Yup.date().when(
        MOTOR_FORMIK_KEYS?.ISPOLICYEXPIRED,
        (isPolicyExpired, schema) => {
          if (isPolicyExpired === POLICY_TYPES?.NOT_EXPIRED) {
            return schema.required(FORM_ERROR_MESSAGES?.expiryDate)
          }
          return schema
        }
      ),
      expiredDate: Yup.string().when(
        MOTOR_FORMIK_KEYS?.ISPOLICYEXPIRED,
        (isPolicyExpired, schema) => {
          if (isPolicyExpired === POLICY_TYPES?.EXPIRED) {
            return schema.required(FORM_ERROR_MESSAGES?.expiredDate)
          }
          return schema
        }
      ),
      isPolicyExpiredBeforeDate: Yup.string().when(
        MOTOR_FORMIK_KEYS?.ISPOLICYEXPIRED,
        (isPolicyExpired, schema) => {
          if (isPolicyExpired === POLICY_TYPES?.EXPIRED) {
            return schema.required(FORM_ERROR_MESSAGES?.expiredDate)
          }
          return schema
        }
      ),
      thirdPartyStartDate: Yup.string().when(
        [MOTOR_FORMIK_KEYS?.POLICYTYPE, MOTOR_FORMIK_KEYS?.REGDATE],
        {
          is: (policyType, regDate) =>
            policyType === POLICY_TYPE_ENUM?.OWN_DAMAGE && regDate,
          then: (schema) =>
            schema
              .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.thirdPartyStartDate)
              .test(
                'is-less-than-vehicle-registered-date',
                MOTOR_FORMIK_KEYS?.THIRDPAYTYDATE,
                function (value) {
                  return (
                    getNextDate(motorDetailsForm?.values?.regDate) <=
                    getNextDate(value)
                  )
                }
              ),

          otherwise: (schema) => schema,
        }
      ),

      thirdPartyExpiryDate: Yup.date().when(
        [
          MOTOR_FORMIK_KEYS?.EXPIRYDATE,
          MOTOR_FORMIK_KEYS?.POLICYTYPE,
          MOTOR_FORMIK_KEYS?.THIRDPARTYSTARTDATE,
        ],
        {
          is: (expiryDate, policyType, thirdPartyStartDate) =>
            policyType === POLICY_TYPE_ENUM?.OWN_DAMAGE &&
            expiryDate &&
            thirdPartyStartDate,
          then: (schema) =>
            schema
              .required(MOTOR_MEMBER_DETAILS_VALIDATIONS?.thirdPartyExpiryDate)
              .min(
                getNextDate(motorDetailsForm?.values?.expiryDate),
                MOTOR_FORMIK_KEYS?.THIRDPARTYGREATERTHANPREVPOLICY
              )
              .test(
                'is-exactly-3-years-more',
                MOTOR_FORMIK_KEYS?.THIRDPARTYGREATERTHANSTARTDATE,
                function (value) {
                  const thirdPartyStartDate = new Date(
                    motorDetailsForm?.values?.thirdPartyStartDate
                  )
                  const thirdPartyExpiryDate = new Date(value)
                  const threeYearsAfter = new Date(
                    thirdPartyStartDate?.getFullYear() + 3,
                    thirdPartyStartDate?.getMonth(),
                    thirdPartyStartDate?.getDate()
                  )
                  if (thirdPartyStartDate?.getDate() === 1) {
                    threeYearsAfter?.setDate(0)
                  } else {
                    threeYearsAfter?.setDate(threeYearsAfter?.getDate() - 1)
                  }
                  return (
                    thirdPartyExpiryDate?.getTime() ===
                    threeYearsAfter?.getTime()
                  )
                }
              ),
          otherwise: (schema) => schema,
        }
      ),
      thirdPartyProvider: Yup.string().when(
        MOTOR_FORMIK_KEYS?.POLICYTYPE,
        (policyType, schema) => {
          if (policyType === POLICY_TYPE_ENUM?.OWN_DAMAGE) {
            return schema.required(
              MOTOR_MEMBER_DETAILS_VALIDATIONS?.thirdPartyInsuranceProvider
            )
          }
          return schema
        }
      ),
      thirdPartyPolicyNo: Yup.string().when(
        MOTOR_FORMIK_KEYS?.POLICYTYPE,
        (policyType, schema) => {
          if (policyType === POLICY_TYPE_ENUM?.OWN_DAMAGE) {
            return schema.required(
              MOTOR_MEMBER_DETAILS_VALIDATIONS?.thirdPartyPolicyNumber
            )
          }
          return schema
        }
      ),
      thirdPartyProviderFirstName: Yup.string(),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values, setSubmitting)
    },
    enableReinitialize: true,
  })

  const handlePrefillData = async () => {
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.ISPOLICYEXPIRED,
      previousPolicyDetails?.isPolicyExpired
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.EXPIRYDATE,
      previousPolicyDetails?.expiryDate
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.EXPIRYDATE,
      previousPolicyDetails?.expiredDate
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.NCB,
      previousPolicyDetails?.ncb
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.EXISTINGPOLICYCLAIM,
      previousPolicyDetails?.existingPolicyClaim
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.COMPANYNAME,
      vehicleDetails?.companyName
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.POLICYTYPE,
      currentPolicyDetails?.policyType
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.ISCOMPANY,
      vehicleDetails?.isCompany
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.PREVPOLICYNUMBER,
      previousPolicyDetails?.previousPolicyNumber
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.PREVPOLICYPROVIDER,
      previousPolicyDetails?.previousPolicyProvider?.insuranceCompanyName || ''
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.EMAIL,
      personalDetails?.email
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.NAME,
      personalDetails?.name
        ? personalDetails?.name
        : loggedInUserInfo?.userInfo?.userData?.firstName ?? '',
      true
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.MOBILENUMBER,
      personalDetails?.mobileNumber
        ? personalDetails?.mobileNumber
        : loggedInUserInfo?.userInfo?.userData?.mobileNumber ?? '',
      true
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.THIRDPARTYEXPIREDDATE,
      previousPolicyDetails?.thirdPartyExpiryDate || '',
      true
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.THIRDPARTYSTARTDATE,
      previousPolicyDetails?.thirdPartyStartDate,
      true
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.THIRDPARTYPROVIDER,
      previousPolicyDetails?.thirdPartyProvider,
      true
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.THIRDPARTYPOLICYNO,
      previousPolicyDetails?.thirdPartyPolicyNo,
      true
    )
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.THIRDPARTYPROVIDERFIRSTNAME,
      previousPolicyDetails?.thirdPartyProviderFirstName,
      true
    )
  }
  const handleRadioClick = (event) => {
    setSelectedValue(event?.target?.value)
    setPopoverAnchor(event?.currentTarget)
    setIsPopoverOpen(true)
  }

  const closePopover = () => {
    setIsPopoverOpen(false)
    setPopoverAnchor(null)
  }
  const getPopoverComponent = () => {
    switch (selectedValue) {
      case expired?.expired:
        return (
          <>
            <Box>
              <ExpiryPopOver
                formOne={motorDetailsForm}
                closePopover={closePopover}
              />
            </Box>
          </>
        )
      case expired?.notExpired:
        return (
          <>
            <Box>
              <ExpiryPopOver
                isExpired={true}
                formOne={motorDetailsForm}
                closePopover={closePopover}
              />
            </Box>
          </>
        )
      case existingClaims?.no:
        return (
          <>
            <Box>
              <ExistingClaimsPopOver
                formOne={motorDetailsForm}
                closePopover={closePopover}
              />
            </Box>
          </>
        )
      default:
        return
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const token = response?.res?.data?.access_token
      dispatch(updateTokenMotor(token))
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const handleIsPolicyExpiredChange = (event) => {
    motorDetailsForm.setFieldValue(
      MOTOR_FORMIK_KEYS?.ISPOLICYEXPIRED,
      event?.target?.value,
      true
    )
    motorDetailsForm.setFieldValue(MOTOR_FORMIK_KEYS?.EXPIRYDATE, '', true)
    motorDetailsForm.setFieldValue(MOTOR_FORMIK_KEYS?.EXPIREDDATE, '', true)
  }

  useEffect(() => {
    fetchToken()
    handlePrefillData()
    if (personalDetails?.name) {
      setFormActive(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getVehicleNickName = () => {
    return vehicleDetails?.nickName ? vehicleDetails?.nickName : KUTTI
  }

  const handleNextClick = () => {
    dispatch(
      showNotificationMessage({
        type: NOTIFICATION_TYPES?.WARNING,
        message: FILL_REQ_FIELDS,
      })
    )
    setIsHighlight(true)
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <Popover
        id={'popover'}
        open={isPopoverOpen}
        anchorEl={popoverAnchor}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {getPopoverComponent()}
      </Popover>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box className={classes.modalStyle}>
            <Box className={classes.formSectionMain}>
              <Box className={classes.formSectionOne}>
                <Box className={classes.detailsReadyText}>
                  <span className={'capitalize'}>{getVehicleNickName()}</span>
                  &apos;s details are ready
                </Box>
                <Box className={`${isActiveSection ? classes.active : ''}`}>
                  <CarDetails
                    Logo={motorFourWheeler}
                    setIsActiveSection={setIsActiveSection}
                  />
                </Box>
                <Box
                  className={`${
                    !isActiveSection ? classes.active : classes.inactive
                  }`}
                >
                  <Box
                    className={`${classes.formCardTwo} ${
                      isHighlight ? classes.highlightSection : ''
                    }`}
                  >
                    <FormControl>
                      <FormLabel
                        id='motor-buttons-group-label'
                        className={classes.formHeadingLabel}
                      >
                        Policy Expire Details
                      </FormLabel>
                      <RadioGroup
                        row
                        name='isPolicyExpired'
                        value={motorDetailsForm?.values?.isPolicyExpired}
                        onChange={(e) => handleIsPolicyExpiredChange(e)}
                      >
                        <Box className={classes.radioButtonOptions}>
                          {radioOptions?.map((option) => (
                            <FormControlLabel
                              key={option?.value}
                              value={option?.value}
                              control={<Radio size='small' />}
                              label={
                                <Box className={classes.formRadioText}>
                                  {option?.label}
                                </Box>
                              }
                              onClick={handleRadioClick}
                            />
                          ))}
                        </Box>
                      </RadioGroup>
                    </FormControl>

                    {!motorDetailsForm?.expiryDate && (
                      <FormHelperText className={classes.errorStyle}>
                        {motorDetailsForm?.touched?.expiryDate &&
                          motorDetailsForm?.errors?.expiryDate}
                      </FormHelperText>
                    )}

                    <FormHelperText className={classes.errorStyle}>
                      {motorDetailsForm?.touched?.isPolicyExpired &&
                        motorDetailsForm?.errors?.isPolicyExpired}
                    </FormHelperText>
                    {motorDetailsForm?.values?.expiryDate ? (
                      <Box className={classes.bottomValueText}>
                        Your policy expires on:{' '}
                        {formatDateMonth(motorDetailsForm?.values?.expiryDate)}
                      </Box>
                    ) : null}
                  </Box>
                </Box>
                <Box
                  className={`${
                    !isActiveSection ? classes.active : classes.inactive
                  }`}
                >
                  <Box
                    className={`${classes.formCardTwo} ${
                      isHighlight ? classes.highlightSection : ''
                    }`}
                  >
                    <FormControl>
                      <FormLabel
                        id='motor-buttons-claim-label'
                        className={classes.formHeadingLabel}
                      >
                        Claims on existing policy?
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby='motor-radio-buttons-claim-label'
                        name='motor-buttons-claim'
                        value={motorDetailsForm?.values?.existingPolicyClaim}
                        onChange={(e) => {
                          motorDetailsForm.setFieldValue(
                            MOTOR_FORMIK_KEYS?.EXISTINGPOLICYCLAIM,
                            e?.target?.value,
                            true
                          )
                          if (e?.target?.value === YES) {
                            motorDetailsForm.setFieldValue(
                              MOTOR_FORMIK_KEYS?.NCB,
                              0,
                              true
                            )
                          }
                          setIsHighlight(false)
                          setFormActive(true)
                        }}
                        className={classes.radioButtonOptions}
                      >
                        <FormControlLabel
                          value='yes'
                          control={<Radio size='small' />}
                          label={
                            <Box className={classes.formRadioText}>Yes</Box>
                          }
                        />
                        <FormControlLabel
                          className={classes.formRadioText}
                          value='no'
                          control={<Radio size='small' />}
                          label={
                            <Box className={classes.formRadioText}>No</Box>
                          }
                          onClick={handleRadioClick}
                        />
                      </RadioGroup>
                      {!motorDetailsForm.ncb && (
                        <FormHelperText className={classes.errorStyle}>
                          {motorDetailsForm?.touched?.ncb &&
                            motorDetailsForm?.errors?.ncb}
                        </FormHelperText>
                      )}
                      <FormHelperText className={classes.errorStyle}>
                        {motorDetailsForm?.touched?.existingPolicyClaim &&
                          motorDetailsForm?.errors?.existingPolicyClaim}
                      </FormHelperText>
                    </FormControl>
                    {motorDetailsForm?.values?.ncb === 0 ||
                    motorDetailsForm?.values?.ncb > 0 ? (
                      <Box className={classes.bottomValueText}>
                        Your current ncb value is:{' '}
                        {motorDetailsForm?.values?.ncb}%
                      </Box>
                    ) : null}
                  </Box>
                </Box>
                {!formActive && (
                  <Box className={classes.skipBtnContainer}>
                    <ArrowRightAltIcon
                      onClick={handleNextClick}
                      fontSize='large'
                      className={classes.skipBtn}
                    />
                  </Box>
                )}
              </Box>
              <Box className={classes.formSectionTwo}>
                <Box>
                  <Box className={classes.formSectionTwoCloseIcon}>
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <Box
                    className={`${
                      formActive ? classes.active : classes.inactive
                    }`}
                  >
                    <ModelForm
                      formOne={motorDetailsForm}
                      handleSubmit={handleSubmit}
                    />
                  </Box>

                  <Box className={classes.imageActions}>
                    <Box className={classes.secureContent}>Secure your</Box>
                    <Box className={classes.kuttiImageContainer}>
                      <Box className={classes.kuttiImageAction}>
                        <img
                          src={kuttiImage}
                          alt='kutti-image'
                          width={'100%'}
                        />
                      </Box>
                      <Box className={classes.kuttiImageActions}>
                        <img src={gurantee} alt='kutti-image' width={'100%'} />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

export default MotorDialog

const useStyles = makeStyles({
  formSectionMain: {
    display: 'flex',
    backgroundImage: `url(${ImageBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
  },
  formSectionOne: {
    width: '30%',
    borderRight: '1px solid #ccc',
    background:
      'linear-gradient(192.92deg, #ABD3E0 -54.34%, rgba(255, 255, 255, 0) 94.64%)',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    padding: '16px',
  },
  formSectionTwo: {
    width: '70%',
  },
  formSectionTwoCloseIcon: {
    textAlign: 'right',
    right: '0',
    top: '0',
  },
  formCardTwo: {
    border: '1px solid #4DC3E3',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    flexWrap: 'wrap',
    margin: '0px 20px',
  },
  formCardThree: {},
  formHeadingLabel: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#000000 !important',
  },
  formRadioText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    marginLeft: '-8px',
  },
  imageActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 50,
    gap: 10,
  },
  secureContent: {
    fontFamily: 'Roboto',
    fontSize: '26px',
    fontWeight: 600,
    color: '#D7D7D7',
  },
  kuttiImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  kuttiImageActions: {
    zIndex: 2,
    position: 'absolute',
    left: '80%',
    top: '9%',
  },
  kuttiImageAction: {
    zIndex: 1,
  },
  active: {
    opacity: 1,
  },
  inactive: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  errorStyle: {
    color: 'red !important',
  },
  radioButtonOptions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  detailsReadyText: {
    textAlign: 'center',
    paddingTop: 35,
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    width: '65vw',
  },
  bottomValueText: {
    fontSize: '11px',
  },
  skipBtnContainer: {
    display: 'flex',
    margin: '0 20px',
  },
  skipBtn: {
    fontSize: '12px',
    padding: '0px',
    color: '#EF669B',
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  highlightSection: {
    border: '2px solid #EF669B !important',
  },
})
